import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { DocumentService } from '../../../general/services/document.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SalesForm } from '../../../../features/sales/models/sales-agent.model';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { tap } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { LoaderComponent } from '../../../general/components/loader/loader.component';

@Component({
  selector: 'app-listing-forms',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatSortModule,
    MatCardModule,
    LoaderComponent
  ],
  templateUrl: './listing-forms.html',
  styleUrl: './listing-forms.scss',
})
export class ListingForms implements OnInit {
  private documentService = inject(DocumentService);
  private cdr = inject(ChangeDetectorRef);

  isLoading = false;
  displayedColumns: string[] = ['user', 'agent', 'property', 'status', 'url', 'lastUpdated'];
  dataSource = new MatTableDataSource<SalesForm>();
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.dataSource.paginator = mp;
  }

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.dataSource.sort = ms;
  }

  ngOnInit() {
    this.loadListingForms();
  }

  loadListingForms() {
    this.documentService.getListingForms().pipe(tap((result: SalesForm[]) => {
      console.log(result);
      this.dataSource.data = result;
      this.cdr.detectChanges();
    })).subscribe();
  }
}
